export interface ContainerLengthBayMappingFormProfile {
  id?: string
  length: number | null
  bayCount: number | null
  isStandard: boolean
}

export interface ContainerLengthBayMappingSubmitProfile {
  id?: string
  length: number
  bayCount: number
  isStandard: boolean
}

export const defaultValues: ContainerLengthBayMappingFormProfile = {
  length: null,
  bayCount: null,
  isStandard: false,
}
